export default class UserException extends Error {
  constructor(msg) {
    super();
    this.name = 'UserException';
    this.msg = msg;
    this.stack = (new Error()).stack;
  }
}
